import styled from 'styled-components';

import {
    getPurpurColor,
    getPurpurSpacing,
    getPurpurTypography,
    purpurMedia,
} from '@telialt/common-theme/src/purpurSelectors';

export const BrandFilterContainer = styled.div`
    margin-top: ${getPurpurSpacing('150')};
    margin-bottom: ${getPurpurSpacing('150')};
    padding: ${getPurpurSpacing('150')} ${getPurpurSpacing('50')};
    width: 100%;
    display: flex;
    overflow-x: auto;
    flex-wrap: nowrap;
    gap: ${getPurpurSpacing('150')};
    &::-webkit-scrollbar {
        display: none;
    }

    ${purpurMedia('lg')`
        gap: ${getPurpurSpacing('200')};
        overflow-x: auto;
        flex-wrap: wrap;
    `};
`;

export const BrandFilterContent = styled.span`
    height: ${getPurpurSpacing('300')};
    display: flex;
    align-items: center;
    ${purpurMedia('lg')`
        column-gap: 0.625rem;
        height: 2.75rem;
        padding: 0 ${getPurpurSpacing('50')};
    `}
`;

export const BrandImage = styled.img`
    max-height: ${getPurpurSpacing('300')};
    mix-blend-mode: multiply;
`;

export const BrandFilterCount = styled.span`
    color: ${getPurpurColor('textDefault')};
    font-size: ${getPurpurTypography('scale75')};
    display: none;
    ${purpurMedia('lg')`
        display: revert;
    `}
`;
